// L00K Player
// import { Howl, Howler } from 'howler';
// import Lenis from '@studio-freight/lenis'


// CSS
import '../styles/tapes.scss';
// JS
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { Observer } from "gsap/Observer";


// Svg
// https://parceljs.org/languages/svg/#inlining-as-a-string
import huQrSvg from 'bundle-text:../svg/hu__qr.svg';




// Thing
import play from './components/playEyeHandTwo';
// import hand from './components/hand';

document.addEventListener('DOMContentLoaded', function () {
	gsap.registerPlugin(ScrollTrigger, Observer, SplitText);



	// Inject QR Svg
    const qrSpans = document.querySelectorAll('.l00k__qrCode');
    qrSpans.forEach(function (qrSpan) {
        qrSpan.innerHTML = huQrSvg;
    });

	// L00K NAV
	var toggleLookNav = document.querySelectorAll('.toggle__l00k__nav');
	const mainLook = document.querySelectorAll('.l00k');

	toggleLookNav.forEach(function (toggleButton) {
		if (toggleButton instanceof HTMLButtonElement) {

			toggleButton.onclick = function (event) {

				mainLook.forEach(look => look.classList.toggle("w__l00k__nav"));

				if (toggleButton.getAttribute("aria-expanded") == "true") {
					toggleButton.setAttribute("aria-expanded", "false");
				} else {
					toggleButton.setAttribute("aria-expanded", "true");
				};

			};
		}
	});

	const main = document.querySelector('main');
    const toggleButton = document.querySelector('.toggle__l00k__nav');
    const isDesktop = window.innerWidth >= 1024;
    
    // Check if we came from one of our internal pages
    const referrer = document.referrer;
    const internalPages = ['index.html', 'a2.html', 'a3.html', 'a4.html', 'a5.html'];
    
    if (isDesktop && referrer) {
        const referrerPath = new URL(referrer).pathname;
        const isInternalNavigation = internalPages.some(page => referrerPath.endsWith(page));
        
        if (isInternalNavigation) {
            main.classList.add('w__l00k__nav');
            toggleButton.setAttribute('aria-expanded', 'true');
        }
    }


	// // tapes word scroll


	// var mySplitText = new SplitText("#quote", { type: "chars" });

	// // create an infinite loop
	// let loop = horizontalLoop(".tapes span", { repeat: -1 });
	// // create a tween that'll always decelerate the timeScale of the timeline back to 0 over the course of 0.5 seconds (or whatever)
	// let slow = gsap.to(loop, { timeScale: 0, duration: 1 });
	// // make the loop stopped initially.
	// loop.timeScale(0);

	// // now use an Observer to listen to pointer/touch/wheel events and set the timeScale of the infinite looping timeline accordingly. 
	// Observer.create({
	// 	target: ".tapes",
	// 	type: "pointer,touch,wheel",
	// 	wheelSpeed: -1,
	// 	onChange: self => {
	// 		loop.timeScale(Math.abs(self.deltaX) > Math.abs(self.deltaY) ? -self.deltaX : -self.deltaY); // whichever direction is bigger
	// 		slow.invalidate().restart(); // now decelerate
	// 	}
	// });






	// function horizontalLoop(items, config) {
	// 	items = gsap.utils.toArray(items);
	// 	config = config || {};
	// 	let tl = gsap.timeline({ repeat: config.repeat, paused: config.paused, defaults: { ease: "none" }, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100) }),
	// 		length = items.length,
	// 		startX = items[0].offsetLeft,
	// 		times = [],
	// 		widths = [],
	// 		xPercents = [],
	// 		curIndex = 0,
	// 		pixelsPerSecond = (config.speed || 1) * 100,
	// 		snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
	// 		totalWidth, curX, distanceToStart, distanceToLoop, item, i;
	// 	gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
	// 		xPercent: (i, el) => {
	// 			let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
	// 			xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
	// 			return xPercents[i];
	// 		}
	// 	});
	// 	gsap.set(items, { x: 0 });
	// 	totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0);
	// 	for (i = 0; i < length; i++) {
	// 		item = items[i];
	// 		curX = xPercents[i] / 100 * widths[i];
	// 		distanceToStart = item.offsetLeft + curX - startX;
	// 		distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
	// 		tl.to(item, { xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond }, 0)
	// 			.fromTo(item, { xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100) }, { xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false }, distanceToLoop / pixelsPerSecond)
	// 			.add("label" + i, distanceToStart / pixelsPerSecond);
	// 		times[i] = distanceToStart / pixelsPerSecond;
	// 	}
	// 	function toIndex(index, vars) {
	// 		vars = vars || {};
	// 		(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
	// 		let newIndex = gsap.utils.wrap(0, length, index),
	// 			time = times[newIndex];
	// 		if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
	// 			vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
	// 			time += tl.duration() * (index > curIndex ? 1 : -1);
	// 		}
	// 		curIndex = newIndex;
	// 		vars.overwrite = true;
	// 		return tl.tweenTo(time, vars);
	// 	}
	// 	tl.next = vars => toIndex(curIndex + 1, vars);
	// 	tl.previous = vars => toIndex(curIndex - 1, vars);
	// 	tl.current = () => curIndex;
	// 	tl.toIndex = (index, vars) => toIndex(index, vars);
	// 	tl.times = times;
	// 	tl.progress(1, true).progress(0, true); // pre-render for performance
	// 	if (config.reversed) {
	// 		tl.vars.onReverseComplete();
	// 		tl.reverse();
	// 	}
	// 	return tl;
	// }

}, false);